/* -disable react/style-prop-object */
import React, { Component } from 'react';

// 3rd party
import { FormattedNumber } from 'react-intl';

// Components
import Toggle from '../../../../../../components/Toggle';
import Icon from '../../../../../../components/Icon';

// css
import './styles.css';

export default class UnloadNFTable extends Component {
  render() {
    return (
      <div className="UnloadNFTable_wrapper">
        <table className="UnloadNFTable">
          <thead className="UnloadNFTable__header">
            <tr>
              <td className="UnloadNFTable__header-cell">NF</td>
              <td className="UnloadNFTable__header-cell">Destinatário</td>
              <td className="UnloadNFTable__header-cell">Cidade / UF</td>
              <td className="UnloadNFTable__header-cell">Embalagem</td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-right">
                Volumes (un)
              </td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-right">
                Peso (kg)
              </td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-right">
                Valor (R$)
              </td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-center">
                Avaria
              </td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-center">
                Palletizado
              </td>
              <td className="UnloadNFTable__header-cell UnloadNFTable__cell--align-center">
                Remover
              </td>
            </tr>
          </thead>
          <tbody>
            {this.props.data.map((row, index) => (
              <tr className="UnloadNFTable__row" key={row.nf}>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--highlighted">{`${row.nf}-${row.nfGroup}`}</td>
                <td className="UnloadNFTable__cell">{row.receiver}</td>
                <td className="UnloadNFTable__cell">
                  {row.cidade} / {row.uf}
                </td>
                <td className="UnloadNFTable__cell">
                  {this.props.getLabelById(row.type)}
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--align-right">
                  {row.volume}
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--align-right">
                  <FormattedNumber
                    value={row.weight}
                    style="decimal"
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--align-right">
                  <FormattedNumber
                    value={row.value}
                    style="decimal"
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--align-center">
                  <Toggle
                    className="UnloadNFTable__cell-toggle"
                    isChecked={row.isDamaged}
                    onChange={() => {
                      this.props.onDamagedChange(index);
                    }}
                  />
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--align-center">
                  <Toggle
                    className="UnloadNFTable__cell-toggle"
                    isChecked={row.isPalletized}
                    onChange={() => {
                      this.props.onPalletizedChange(index);
                    }}
                  />
                </td>
                <td className="UnloadNFTable__cell UnloadNFTable__cell--icon UnloadNFTable__cell--align-center">
                  <Icon
                    onClick={() => {
                      this.props.onDelete(index);
                    }}
                    name="delete"
                    className="UnloadNFTable__cell-icon"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
